import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { ChannelType } from '../types';

import { channelsQueryKeys } from './query-keys';

export type TUpdateChannelImagesParams = {
  id: string;
  logo: File;
};

export async function updateChannelImages(
  params: TUpdateChannelImagesParams
): Promise<ChannelType> {
  const formData = new FormData();

  if (params.logo) {
    formData.append('logo', params.logo);
  }

  return mediaManagerClient.patch(`/api/v1/channels/${params.id}/images`, formData);
}

type MutationFn = typeof updateChannelImages;

type TUseUpdateChannelImagesParams = {
  config?: MutationConfig<MutationFn>;
};

export function useUpdateChannelImage({ config = {} }: TUseUpdateChannelImagesParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: updateChannelImages,
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar la imagen'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('Se ha actualizado la imagen'));
      queryClient.invalidateQueries({ queryKey: channelsQueryKeys.all });
    },
  });
}
